import { z } from "zod";

import { dateRangeCodec } from "../table/codecs/filterValueCodecs";

const DATE_FILTER_DELIMITER = ".";

const dateFilterModeSchema = z.enum(["dueDate", "period"]);

/**
 * Any malformed input decodes to `null`, so a stale URL/localStorage value falls back to the default window.
 */
export const controlActivitiesDateFilterCodec = z.codec(
    z.string(),
    z
        .object({
            mode: dateFilterModeSchema,
            range: z
                .tuple([z.string().nullable(), z.string().nullable()])
                .nullable(),
        })
        .nullable(),
    {
        encode: (value) =>
            value
                ? `${value.mode}${DATE_FILTER_DELIMITER}${dateRangeCodec.encode(value.range)}`
                : "null",
        decode: (encString) => {
            const [rawMode, ...rangeParts] = encString.split(
                DATE_FILTER_DELIMITER
            );
            const mode = dateFilterModeSchema.safeParse(rawMode);
            const range = dateRangeCodec.safeDecode(
                rangeParts.join(DATE_FILTER_DELIMITER)
            );
            if (mode.error || range.error) {
                return null;
            }
            return { mode: mode.data, range: range.data };
        },
    }
);
